// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".TableLabel__tableLabel___2OGxW{display:flex;align-items:center;padding:4px 0}.TableLabel__tableLabel___2OGxW.TableLabel__disabled___W_tZv{opacity:0.4}.TableLabel__tableLabelText___3XkSI{font-size:14px;color:#333}\n", ""]);
// Exports
exports.locals = {
	"tableLabel": "TableLabel__tableLabel___2OGxW",
	"disabled": "TableLabel__disabled___W_tZv",
	"tableLabelText": "TableLabel__tableLabelText___3XkSI"
};
module.exports = exports;
